import {
  Blocks,
  Cable,
  Cloud,
  Code,
  Database,
  Globe,
  Settings,
  TestTube,
  Wrench,
} from "lucide-react";

function Skills() {
  const skillCategories = [
    {
      icon: Code,
      title: "使用言語（Languages）",
      skills: [
        "TypeScript",
        "JavaScript",
        "PHP",
        "Go",
        "Kotlin",
        "Python",
        "Ruby",
        "C#",
        "VB",
        "HTML5",
        "CSS3",
      ],
    },
    {
      icon: Settings,
      title: "開発基盤・運用ツール（DevOps）",
      skills: [
        "Git",
        "GitHub Actions",
        "CircleCI",
        "Docker",
        "Terraform",
        "AWS",
        "Datadog",
        "Sentry",
      ],
    },
    {
      icon: Globe,
      title: "JavaScriptライブラリ（Libraries）",
      skills: [
        "Node.js",
        "Deno",
        "Bun",
        "React",
        "Vue.js",
        "jQuery",
        "Vanilla JS",
      ],
    },
    {
      icon: Blocks,
      title: "Webフレームワーク（Frameworks）",
      skills: [
        "Next.js",
        "Nuxt",
        "Express",
        "Hono",
        "Laravel",
        "Echo",
        "Ktor",
        ".NET Framework",
      ],
    },
    {
      icon: Cloud,
      title: "バックエンドサービス（BaaS）",
      skills: ["Amplify", "Netlify", "Hasura"],
    },
    {
      icon: TestTube,
      title: "テストツール（Testing）",
      skills: [
        "Jest",
        "Vitest",
        "Cypress",
        "Postman",
        "PHPUnit",
        "go test",
        "JUnit5",
      ],
    },
    {
      icon: Database,
      title: "データベース(DB)",
      skills: ["MySQL", "PostgreSQL", "DynamoDB", "Redis"],
    },
    {
      icon: Cable,
      title: "API / 通信（API）",
      skills: [
        "REST",
        "GraphQL",
        "OpenAPI(Swagger)",
        "OpenAPI(Stoplight)",
        "Webhook",
      ],
    },
    {
      icon: Wrench,
      title: "開発ツール・その他（Tools）",
      skills: [
        "VS Code",
        "IntelliJ IDEA",
        "Cursor",
        "Notion",
        "Backlog",
        "Slack",
        "Zoom",
        "ovice",
        "Stoplight",
        "Figma",
        "DBeaver",
      ],
    },
  ];

  return (
    <section
      id="skills"
      className="bg-blue-50 px-6 py-16 md:px-12 md:py-24 lg:px-24"
    >
      <div className="fade-in-section mx-auto max-w-7xl">
        <div className="mb-10 space-y-4 text-center md:mb-12">
          <div className="mb-12 text-center md:mb-16">
            <h2 className="mb-4 text-xl font-bold text-gray-900 md:text-2xl">
              スキル・技術スタック
            </h2>
            <div className="mx-auto h-1 w-20 bg-blue-600"></div>
          </div>
          <p className="mx-auto max-w-2xl leading-relaxed text-gray-600">
            スケーラビリティを意識したWebアプリケーション開発を強みとし、CI/CDや監視・運用改善などDevOpsの実践を通じて、開発から運用まで一貫してプロダクトを支えます。
            <br />
            フロントエンド／バックエンド／クラウド基盤までモダンな技術スタックを横断して対応可能です。
          </p>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {skillCategories.map((category, index) => {
            const IconComponent = category.icon;
            return (
              <div
                key={index}
                className="fade-in-section flex h-full flex-col gap-6 rounded-xl border border-gray-200 bg-white text-gray-900 shadow-sm"
                style={{ transitionDelay: `${index * 50}ms` }}
              >
                <div className="px-6 pt-6">
                  <h4 className="flex items-center gap-3 leading-none">
                    <IconComponent className="h-5 w-5 text-blue-600" />
                    {category.title}
                  </h4>
                </div>
                <div className="px-6 pb-6">
                  <div className="flex flex-wrap gap-2">
                    {category.skills.map((skill) => (
                      <span
                        key={skill}
                        className="inline-flex w-fit shrink-0 items-center justify-center gap-1 rounded-md border border-gray-200 bg-gray-100 px-2 py-1 text-xs font-medium whitespace-nowrap text-gray-800"
                      >
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Skills;
